<template>
    <div>
        <div class="relative">
            <div class="absolute items-center pl-6 top-10 sm:hidden">
                <img class="w-4" src="../../../assets/arrow/back.png" @click="clickBack()">
            </div>
            <div class="flex justify-center pt-3">
                <img class="h-20" src="../../../assets/logo/tipcoin-logo-top.png">
            </div>
        </div>

    </div>
</template>
<script>

import AuthStatusMixin from "@/mixin/AuthStatusMixin";

export default {
    name: 'TopBar',
    mixins: [AuthStatusMixin],
    components: {

    },
    props: {
        title: { type: String, default: '' },
        isShowOnlyLogo: { type: Boolean, default: false },
        modalController: { type: Object, required: true },
    },
    methods:{
        // AuthStatusMixin
        onAccountInit: function() {
            if (this.isLogin) {
                // console.log('profile', this.profile);
            }
        },
        clickBack: function () {
            this.$router.back();
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .logo-size {
        width: 100px;
        height: 90px;
    }
    .logo-mobile-size {
        width: 65px; //53px
        height: 58px;
    }
    .mobile-top {
        height: $topbar-height-mobile;
    }
</style>
